import styled, { css } from 'styled-components';
import { Alert } from 'antd';

const AlertMargin = css`
  .ant-alert-message {
    margin-bottom: 24px;
  }
`;

interface IStyledAlert {
  withMarginBottom?: boolean;
}

export const StyledAlert = styled(Alert)<IStyledAlert>`
  margin-bottom: 24px;

  ${props => (props.withMarginBottom ? AlertMargin : null)}
`;

export const DescriptionList = styled.ul`
  list-style: none;
  margin-left: 8px;
`;

export const DescriptionListItem = styled.li`
  strong:first-of-type {
    margin-right: 4px;
  }

  &::before {
    content: '-';
    padding-right: 8px;
  }
`;
